import { FontFamily as FontFamilyExtension } from '@tiptap/extension-font-family';

// We had to add " " around the font family name to support font families with numbers and special characters.
// Without the quotes, we were unable to apply font families like Source Sans 3
export const FontFamily = FontFamilyExtension.extend({
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            parseHTML: (element) => element.style.fontFamily?.replace(/['"]+/g, ''),
            renderHTML: (attributes) => {
              if (!attributes.fontFamily) {
                return {};
              }

              return {
                style: `font-family: "${attributes.fontFamily}"`,
              };
            },
          },
        },
      },
    ];
  },
});
